import { CostCenterAssignment, FormattedAssignment } from './types'

export const formatAssignments = (assignments: CostCenterAssignment[]): FormattedAssignment[] => {
  return assignments.map((assignment) => ({
    id: String(assignment.id),
    name: assignment.costCenter.name,
    percentage: assignment.percentage,
    startDate: assignment.startDate,
    endDate: assignment.endDate ?? undefined,
    costCenterId: assignment.costCenter.id,
  }))
}
